export { soovinMyya };

const soovinMyya = () => {
    if (MODULE_NAME === "soovin_myya") {
        var $wrapper = $(".packets-most-popular");
        $(".button", $wrapper).on("click", function () {
            $("[data-packets-most-popular-hidden]").show();
            $(".packets-container").css({
                "opacity": .2,
                "pointer-events": "none"
            })
        });
        $(".close-btn").on("click", function () {
            $("[data-packets-most-popular-hidden]").hide();
            $(".packets-container").css({
                "opacity": 1,
                "pointer-events": "auto"
            })
        });
    }
}